import React, { useContext } from 'react';
import './PromotionStateCountdown.css';
import { DateCountdown } from '../../../../../../shared/src/components/DateCountdown';
import { ForceUpdateContext } from '../../../../../../shared/src/contexts/force-update.context';

export const PromotionStateCountdown = ({
    className = '',
    tillDateObj,
    text,
}) => {
    const forceRerenderPromotions = useContext(ForceUpdateContext);

    return (
        <div className={`${className} lt-promotion-countdown`}>
            <div
                className="lt-promotion-countdown__text"
                dangerouslySetInnerHTML={{ __html: text }}
            />
            <DateCountdown
                className="lt-promotion-countdown__clock"
                tillDateTimestamp={tillDateObj.getTime()}
                countdownEndHandler={forceRerenderPromotions}
            />
        </div>
    );
};
